import { useState, Suspense, lazy, useEffect } from 'react'
import * as Sentry from '@sentry/react'

const SaleElement = ({ vaType, path }) => {
  const [Sale, setSale] = useState('')
  useEffect(() => {
    try {
      const LoadedElement = lazy(() => import(`./${vaType}/${path}/${path}.jsx`))
      setSale(LoadedElement)
    } catch (error) {
      if (import.meta.env.PROD) {
        Sentry.captureException(error, { extra: { context: 'SaleElementError' } })
      }
    }
  }, [])

  if (Sale === '') {
    return ''
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Sale />
    </Suspense>
  )
}

export default SaleElement
